module.exports = __webpack_public_path__ + "media/images/empty-cart-ad305fb8bf78468ae3a0396fc3613b6a.png";